// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"2b31c2ae","164":"6822aec0","254":"759af826","301":"82b82ffe","444":"eb11512c","453":"68cfe6f3","721":"d4d1a6b0"}[chunkId] + ".chunk.js";
};